import React from 'react';

import { colors, fonts, container, sectionHeading, line } from '../theme';
import { venueSteps, PARTNERS_EMAIL } from '../data';

const APPLY_MAILTO =
  `mailto:${PARTNERS_EMAIL}?subject=Venue%20promo%20application` +
  '&body=Venue%20name%3A%0ANeighborhood%3A%0AContact%20name%20%26%20role%3A%0APhone%3A%0APromo%20you%27d%20like%20to%20feature%3A';
const TALK_MAILTO = `mailto:${PARTNERS_EMAIL}?subject=Lyfe%20for%20venues`;

const benefits = [
  "Reach Miami nightgoers the moment they’re deciding where to go",
  'Turn slow nights into full rooms with live, time-boxed deals',
  'Track claims and check-ins from a simple venue dashboard',
];

export default function ForVenues() {
  return (
    <section id="venues" style={{ position: 'relative', borderTop: line.faint, overflow: 'hidden' }}>
      <div
        style={{
          position: 'absolute',
          right: -140,
          top: -120,
          width: 480,
          height: 480,
          borderRadius: '9999px 0 0 9999px',
          background: 'radial-gradient(circle at 70% 50%,rgba(232,99,43,.18),transparent 64%)',
          pointerEvents: 'none',
        }}
      />
      <div
        style={{
          position: 'absolute',
          left: -160,
          bottom: -160,
          width: 520,
          height: 520,
          borderRadius: '0 9999px 9999px 0',
          background: 'radial-gradient(circle at 30% 50%,rgba(49,56,236,.18),transparent 65%)',
          pointerEvents: 'none',
        }}
      />
      <div
        className="lyfe-wrap lyfe-sec lyfe-g2"
        style={{
          ...container,
          position: 'relative',
          padding: '130px 40px 120px',
          display: 'grid',
          gridTemplateColumns: '1.05fr .95fr',
          gap: 72,
          alignItems: 'center',
        }}>
        <div className="lyfe-reveal">
          <div
            style={{
              fontSize: 12,
              letterSpacing: '.24em',
              textTransform: 'uppercase',
              color: colors.orange,
              fontWeight: 600,
              marginBottom: 20,
            }}>
            For venues
          </div>
          <h2 className="lyfe-h2" style={sectionHeading}>
            Put your promo
            <br />
            in front of the
            <br />
            whole city.
          </h2>
          <p style={{ fontSize: 18, lineHeight: 1.6, color: colors.muted, margin: '26px 0 0', maxWidth: 480 }}>
            Bars, clubs, restaurants and live venues across Miami use Lyfe to fill quiet hours and reach people who are
            out <em style={{ fontStyle: 'italic', color: colors.ink }}>right now</em>. Apply to feature your deal — it's
            free to get listed.
          </p>
          <ul style={{ listStyle: 'none', margin: '34px 0 0', display: 'flex', flexDirection: 'column', gap: 16 }}>
            {benefits.map((b) => (
              <li key={b} style={{ display: 'flex', gap: 14, alignItems: 'flex-start', fontSize: 16, color: colors.muted }}>
                <span style={{ color: colors.blue, fontSize: 18, lineHeight: 1.4 }}>→</span> {b}
              </li>
            ))}
          </ul>
          <div style={{ display: 'flex', gap: 14, marginTop: 40, flexWrap: 'wrap' }}>
            <a
              className="lyfe-btn lyfe-fill"
              href={APPLY_MAILTO}
              style={{
                background: colors.ink,
                color: colors.bg,
                fontWeight: 600,
                fontSize: 15,
                padding: '16px 32px',
                borderRadius: 999,
                textDecoration: 'none',
              }}>
              Apply to feature your promo
            </a>
            <a
              className="lyfe-btn lyfe-ghost"
              href={TALK_MAILTO}
              style={{
                border: '1px solid rgba(255,255,255,.24)',
                color: colors.ink,
                fontSize: 15,
                padding: '16px 32px',
                borderRadius: 999,
                textDecoration: 'none',
              }}>
              Talk to our team
            </a>
          </div>
        </div>

        <div
          className="lyfe-reveal"
          style={{
            border: line.card,
            borderRadius: 22,
            background: colors.bgAlt,
            padding: 40,
            boxShadow: '0 40px 90px rgba(0,0,0,.5)',
          }}>
          <div style={{ fontFamily: fonts.serif, fontStyle: 'italic', fontSize: 20, color: colors.muted2, marginBottom: 8 }}>
            Get featured
          </div>
          <div style={{ fontSize: 24, fontWeight: 600, marginBottom: 28 }}>Three steps to go live</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 22 }}>
            {venueSteps.map((s) => (
              <div key={s.n} style={{ display: 'flex', gap: 18, alignItems: 'flex-start' }}>
                <span
                  style={{
                    flex: 'none',
                    width: 38,
                    height: 38,
                    borderRadius: '50%',
                    border: `1px solid ${s.accent === 'orange' ? 'rgba(232,99,43,.5)' : 'rgba(87,96,242,.5)'}`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontFamily: fonts.serif,
                    color: s.accent === 'orange' ? colors.orange : colors.indigo,
                  }}>
                  {s.n}
                </span>
                <div>
                  <div style={{ fontSize: 17, fontWeight: 600 }}>{s.title}</div>
                  <div style={{ fontSize: 15, lineHeight: 1.55, color: colors.muted3, marginTop: 4 }}>{s.body}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
